import React, { Component } from "react";
import moment from 'moment';
import LiveClassDetails from '../home/LiveClassDetails';
import CancelBooking from '../home/CancelBooking';
import BookmarkedClasses from '../home/BookmarkedClasses';
import { showMainErrorPop } from '../../actions/popups';
import { connect } from "react-redux";
import { bookmarkClass } from  '../../utils/bookmarkClass';
import { openLiveClass } from  '../../utils/openLiveClass';

import Language from '../../services/contentData';
import recordingSession from "../../utils/recordingSession";

import axiosVirdioT from '../../utils/axios';
var axiosVirdio;

class MarketplaceMySchedule extends Component {
  
  constructor(props) {
	super(props);
	
	this.state={
		chosenInterest: '',
		allClasses: [],
		classesDates: [],
		classesByInterest: [],
		classInfo: {},
		classBoking: false,
		sessionToCancel: 0,
		sessionToCancelHost: false,
		currentUserData: localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : {},
		startDate: '',
		currentMonthYear: '',
		endDate: '',
		isOpenBookmark: false,
		monthsArray: [],
		chosenMonth: '',
		defaultJoinTime: localStorage.getItem('userData') ? parseInt(JSON.parse(localStorage.getItem('userData')).default.defaultSessionDuration) : 15,
		calendarDays: [],
		isLoadedClasses: false,
		chosenDay: '',
		emptyState: '',
		classInterests: [],
		showLiveTab: 1,
		recordingsFound: false,
		recordingsList: [],
		renderChild: false
    }
	
	this.bookmarkClass = bookmarkClass.bind(this);
	this.openLiveClass = openLiveClass.bind(this);
	
	this.recordSession = new recordingSession();
}
 
componentDidMount(){
	axiosVirdio = new axiosVirdioT(this.props);
	if ( this.state.currentUserData.showLiveAndOnDemand )
		{
				this.createMonths(1);
		}
	else
		{
			this.createMonths(1, true);
		}
		
	this.checkIsLiveTabVisible();
	
	var mainThis = this;
	if ( window['electron'] && JSON.parse(localStorage.getItem('userData')).userType === 1 )
		{
			this.recordSession.checkOldRecordings(function (foundFiles)
			{
				if ( foundFiles )
					{
						console.log('Inside files', foundFiles);
						
						for ( var i = 0; i < foundFiles.length; i++ )
							{
								if ( foundFiles[i].hostId !== JSON.parse(localStorage.getItem('userData')).id ) 
									{
										foundFiles.splice(i, 1);
									}
							}
							
						if ( foundFiles.length > 0 )
							{
								mainThis.setState({'recordingsFound': true, 'recordingsList': foundFiles});
							}
						else
							{
								mainThis.setState({'recordingsFound': false, 'recordingsList': []});
							}
					}
			});
		}
}

checkIfOpenedBookmarkTab = ()=>{
	if ( this.state.isOpenBookmark )
		{
			this.setState({
				renderChild: true
			}, ()=>{ this.setState({renderChild: false});});
		}
}

checkIsLiveTabVisible=()=>{
	
	let userInfo = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : {};
	if ( userInfo.channelSettings )
		{
			this.setState({
				showLiveTab: userInfo.channelSettings.showLiveTab}, ()=>{
					console.log('this.state.showLiveTab', this.state.showLiveTab);
				});
		}
}

createMonths=(mod, loader)=>{
	//console.log('createMonths');
	//send number how much years you want to create from current year
	var dt = new Date();
	var currentYear = dt.getFullYear();
	var currentMonth = dt.getMonth();
	let topDate = new Date((new Date().getFullYear()+mod), 11, 1);
	let fistDayMonth = new Date(currentYear, currentMonth, 1);
	
	let dates = [];
	while ( fistDayMonth <= topDate )
		{
			var cmonth = moment(topDate).format('MMMM')+' '+ topDate.getFullYear();
			/* console.log('cmonth');
			console.log(cmonth); */
			var fullTime = moment(topDate).format('YYYY-MM-DD HH:mm');
			/* console.log('fullTime');
			console.log(fullTime); */
			
			/* console.log('fistDayMonth');
			console.log(moment(fistDayMonth).format('MMMM'));
			
			console.log('topDate');
			console.log(moment(topDate).format('MMMM')); */
			
			if ( moment(fistDayMonth).format('MMMM')+' '+ fistDayMonth.getFullYear() == moment(topDate).format('MMMM')+' '+ topDate.getFullYear() )
				{
					fullTime = moment().startOf('day')
					/* console.log('fullTime2');
					console.log(fullTime); */
				}
			dates.push({
					date: cmonth, 
					date2: fullTime
				});
			if ( topDate.getMonth() == 0 )
				{
					topDate.setMonth(11);
					topDate.setYear(topDate.getFullYear()-1);
				}
			else
				{
					topDate.setMonth(topDate.getMonth()-1);
				}
		}
	let reverseMonths = dates.reverse();
	this.setState({
		currentMonthYear: reverseMonths[0]['date2'],
		monthsArray: reverseMonths
	}, ()=>{ this.choseMonth(this.state.currentMonthYear, loader);});
}

getMyScheduleClasses=(startDate, endDate, showLoader)=>{
	let token = JSON.parse(localStorage.getItem('userData')).token;
    axiosVirdio.auth(token);
	if ( showLoader )
		{
			this.props.updateStateFromChild({showLoader: true});
		}
	axiosVirdio.post(process.env.REACT_APP_API_URL +'/api/v1/session/getMyScheduleClasses', {'startDate': startDate, 'endDate': endDate}).then(res => {
		var mainResponse = res.data.responseData;
		let finalAllClasses = mainResponse.myScheduleClasses;
		let allInterests = mainResponse.classInterests;
		this.props.updateStateFromChild({showLoader: false});
			
		this.setState({
			allClasses: finalAllClasses,
			classInterests: allInterests,
			isLoadedClasses: true
		}, () => {this.setClassesByInterest(startDate)});
	}).catch(err =>{ 
		if ( showLoader )
			{
				this.props.updateStateFromChild({showLoader: false});
			}
	});   
}

setClassesByInterest=(chosenDate)=>{
	var currentDate = new Date();
	var tomorrowDate = new Date().setDate(new Date().getDate() + 1);
	var classDates = [];
	var classDatesFormated = [];
	var allClasses = this.state.allClasses;
	var liveClassesArray = [];
	var liveClassesArrayFormated = [];
	
	for ( var i = 0; i < allClasses.length; i++ )
		{
			var item = allClasses[i];
			var date = moment(item.scheduleDate).format('dddd, DD MMMM');
			var dateFormatedDay = parseInt(moment(item.scheduleDate).format('DD'));
			
			/* console.log('for1');
			console.log('date');
			console.log(date);
			console.log('currentDate');
			console.log(moment(currentDate).format('dddd, DD MMMM'));
			console.log('tomorrowDate');
			console.log(moment(tomorrowDate).format('dddd, DD MMMM'));
			console.log('item.scheduleDate');
			console.log(moment(item.scheduleDate).format('dddd, DD MMMM')); */
			
			if ( moment(currentDate).format('dddd, DD MMMM') == moment(item.scheduleDate).format('dddd, DD MMMM') )
				{
					date = 'Today, ' + moment(item.scheduleDate).format('DD MMMM');
				}
				
			if ( moment(tomorrowDate).format('dddd, DD MMMM') == moment(item.scheduleDate).format('dddd, DD MMMM') )
				{
					date = 'Tomorrow, ' + moment(item.scheduleDate).format('DD MMMM');
				}
				
			if ( classDates.indexOf(date) == -1 ) { classDates.push(date); classDatesFormated.push(dateFormatedDay); }
		}

	for ( var y = 0; y < classDates.length; y++ )
		{
			for ( var z = 0; z < allClasses.length; z++ )
				{
					var itemClass = allClasses[z];
					
					var dateSession = moment(itemClass.scheduleDate).format('dddd, DD MMMM');
					var dateSessionFormated = moment(itemClass.scheduleDate).date();
					/* console.log('for2');
					console.log('dateSession');
					console.log(dateSession);
					console.log('dateSessionFormated');
					console.log(dateSessionFormated);
					console.log(dateSessionFormated);
					console.log('currentDate');
					console.log(moment(currentDate).format('dddd, DD MMMM'));
					console.log('tomorrowDate');
					console.log(moment(tomorrowDate).format('dddd, DD MMMM'));
					console.log('itemClass.scheduleDate');
					console.log(moment(itemClass.scheduleDate).format('dddd, DD MMMM')); */
					
					if ( moment(currentDate).format('dddd, DD MMMM') == moment(itemClass.scheduleDate).format('dddd, DD MMMM') )
						{
							dateSession = 'Today, ' + moment(itemClass.scheduleDate).format('DD MMMM');
						}
						
					if ( moment(tomorrowDate).format('dddd, DD MMMM') == moment(itemClass.scheduleDate).format('dddd, DD MMMM') )
						{
							dateSession = 'Tomorrow, ' + moment(itemClass.scheduleDate).format('DD MMMM');
						}
						
						
					if ( dateSession == classDates[y] )
						{
							if ( !liveClassesArray[dateSession] ) { liveClassesArray[dateSession] = []; }
							if ( !liveClassesArrayFormated[dateSessionFormated] ) { liveClassesArrayFormated[dateSessionFormated] = []; }
							
							liveClassesArray[dateSession].push(itemClass);
							liveClassesArrayFormated[dateSessionFormated].push(itemClass);
						}
				}
		}
	this.setState({
		classesDates: classDates, 
		classDatesFormated: classDatesFormated,
		classesByInterest: liveClassesArray
	}, ()=> {
			this.countdownTimer();
			this.makeCalendar(liveClassesArrayFormated, chosenDate);
	  });
}

openClassDetails=(id)=>{
	var postData = {classId: id};
	let token = JSON.parse(localStorage.getItem('userData')).token;
    axiosVirdio.auth(token); 
	axiosVirdio.post(process.env.REACT_APP_API_URL +'/api/v1/session/getClassDetails', postData).then(res => {
		
		var timeRemaining = Math.floor((new Date(res.data.responseData.scheduleDate).getTime() - new Date().getTime())/1000);
		res.data.responseData['timeUntil'] = timeRemaining;
		
		this.setState({
			classInfo: res.data.responseData
		}, ()=>{this.props.updateStateFromChild({isOpenDetailedClass: true});});
		
	}).catch(err =>{ });   
}

openCancel=(id, isHostCancel?)=>{
	this.setState({
		classBoking: true, 
		sessionToCancel: id,
		sessionToCancelHost: isHostCancel ? true : false
	});
}

updateStateFromChild=(state)=>{
	this.setState(state);
}

closeDetails=(id)=>{
	this.props.closeDetails();
	this.cancelSessionStatus(id);
}

updateParent=(id)=>{
	this.closeDetails(id);
}

cancelSessionStatus = (sessionId)=>{
	let temp = this.state.allClasses;
	
	for (let i=0; i<temp.length; i++)
		{
			if ( temp[i]['sessionId'] == sessionId )
				{
					temp.splice(i,1);
				}
		}
	
	this.setState({
		allClasses: temp,
		classBoking: false
	}, ()=>{ this.setClassesByInterest(this.state.currentMonthYear) });
}

makeCalendar=(data, date)=>{	
	var days = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
	var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	var currentDayInMonth = (new Date()).getDate();
	var currentYear = (new Date()).getFullYear();
	var currentMonth = (new Date()).getMonth();
	
	var dt = new Date(date);
	var pickedYear = dt.getFullYear();
	var pickedMonth = dt.getMonth();
	var startDayInMonth = dt.getDate();
	
	var firstDay = (new Date(pickedYear, pickedMonth, 1)).getDay();
	
	var totalDaysInMonth = this.daysInMonth(pickedMonth, pickedYear);
	
	var weekDays = document.getElementById('weekDays');
	weekDays.innerHTML = '';
	
	let calendarDays = [];
	for (let i=0; i<days.length; i++)
		{
			weekDays.innerHTML += '<div class="weekDay">'+days[i]+'</div>';
		}
	
	for ( let i = 0; i<firstDay; i++ )
		{
			calendarDays.push({
				class1: 'monthDay opac0',
				class2: 'monthDayIn',
				value: ''
			});
		}

	var endDate = 0;
	var twoWeeksDate = new Date(date);
	var twoWeeksFromNow = twoWeeksDate.setDate(new Date(date).getDate() + 13);
	var twoWeeksLimit = new Date(twoWeeksFromNow).getDate();
	
	endDate = twoWeeksLimit;
	var endDateMonth = new Date(twoWeeksFromNow).getMonth();
	
	for ( let i = 1; i<=totalDaysInMonth; i++ )
		{
			if ( i < startDayInMonth )
				{
					calendarDays.push({
						class1: 'monthDay',
						class2: 'monthDayIn',
						value: i
					});
				}
			else
				{	
					let dots = [];
					if ( data[i] && data[i].length > 0 )
						{
							for ( let j=0; j< data[i].length; j++ )
								{
									if ( j < 7 ) 
										{ 
											dots.push({class1: 'bookedMark'});
										} 	
								}
						}
						
					var autoCursor = '';
					if ( dots.length == 0 ) { autoCursor = 'auto_cursor'; } 
						
					if ( pickedYear == currentYear && pickedMonth == currentMonth && currentDayInMonth == i )
						{
							calendarDays.push({
								class1: 'monthDay upcomDays ', //today
								class2: 'monthDayIn',
								class3: 'bookedMarkOut',
								class4: 'bookedMark',
								value: i,
								value2: dots
							});
						}
					else
						{
							var upcomingDay = 'upcomDays';
							if ( i > endDate && pickedMonth == endDateMonth ) { upcomingDay = ''; }
							
							calendarDays.push({
								class1: 'monthDay' + ' ' + upcomingDay,
								class2: 'monthDayIn',
								class3: upcomingDay == '' ? '' : 'bookedMarkOut',
								class4: upcomingDay == '' ? '' : 'bookedMark',
								value: i,
								value2: upcomingDay == '' ? [] : dots
							});
						}
				}
		}
	this.setState({
		calendarDays: calendarDays
	});
	
	if ( this.state.chosenDay != '' )
		{
			this.choseTime(this.state.chosenDay);
		}
	else
		{
			this.setState({
				emptyState: ''
			});
		}
}

daysInMonth = (pickedMonth, pickedYear)=> { 
	var result = (32 - new Date(pickedYear, pickedMonth, 32).getDate());
	return result;
}


openBookmarks=()=>{
	
	if ( this.props && this.props.state && this.props.state.failedPaymentStatus )
		{
			return false;
		}
	
	this.setState({isOpenBookmark: true});
}

choseMonth=(value, mod, mod2)=>{
	if ( value.length != 16 && value.length != undefined )
		{
			value = parseInt(value);
		}
		
	var date1 = new Date(value);
	var lastDay1 = new Date(date1.getFullYear(), date1.getMonth() + 1, 1);
	
	var forTwoWeeks = new Date(value);
	var inTwoWeeks = forTwoWeeks.setDate(forTwoWeeks.getDate () + 14);
	var twoWeeksDate = new Date(inTwoWeeks);
	
	if ( date1.getMonth() == twoWeeksDate.getMonth() ) 
		{
			lastDay1 = twoWeeksDate;
		}
	this.setState({
			currentMonthYear: value,
			chosenDay: (mod2 && mod2 != '') ? mod2 : ''
		}, ()=> {this.getMyScheduleClasses(date1, lastDay1, mod);});
}

bookMarkClass=(e, item)=>{
	e.preventDefault();
	e.stopPropagation();
	
	var mainthis = this;
	var statusClass = 1;
	if ( item.isBookmarked == 1 ) { statusClass = 0; }
	
	this.bookmarkClass(item.sessionId, 1, statusClass).then(function(res){
		mainthis.choseMonth(mainthis.state.currentMonthYear, true, mainthis.state.chosenDay);
	}, function (err) { 
		if ( err.response && err.response.data && err.response.data.errorData ) 
			{
				mainthis.props.showMainErrorPop(err.response.data.errorData); 
			}
	});
}

refreshPage=(loader)=>{
	this.choseMonth(this.state.currentMonthYear, loader, this.state.chosenDay);
}

countdownTimer() {
	let mainthis = this;
    var x = setInterval(function() {
			
			var allClasses = mainthis.state.classesByInterest;
			mainthis.state.classesDates.map((date, index) =>
				{
					mainthis.state.classesByInterest[date].map((item, i) =>
						{
							var timeRemaining = Math.floor((new Date(item.scheduleDate).getTime() - new Date().getTime())/1000);
							allClasses[date][i]['timeUntil'] = timeRemaining;					
						});
				});
			
			mainthis.setState({
					classesByInterest: allClasses
				});
	}, 1000); 
  }

openClass=(id)=>{
	
	console.log('openClass---1', id);
	
	if ( this.props && this.props.state && this.props.state.failedPaymentStatus )
		{
			return false;
		}
	console.log('openClass---2');
	
	this.props.updateStateFromChild({showLoader: true});
	console.log('openClass---3');
	localStorage.removeItem('groupClass');
	this.openLiveClass(id);
	console.log('openClass---4');
}


choseTime = function(id, refresh){
	//console.log('choseTime');
	var currentDate = new Date();
	var tomorrowDate = new Date().setDate(new Date().getDate() + 1);
	var date1 = new Date(this.state.currentMonthYear);
	var pickedDay = new Date(date1.setDate(id));
	var date = moment(pickedDay).format('dddd, DD MMMM');
	
	
	/* console.log('date');
	console.log(date);
	console.log('currentDate');
	console.log(moment(currentDate).format('dddd, DD MMMM'));
	console.log('tomorrowDate');
	console.log(moment(tomorrowDate).format('dddd, DD MMMM'));
	console.log('pickedDay');
	console.log(moment(pickedDay).format('dddd, DD MMMM')); */
	
	if ( moment(currentDate).format('dddd, DD MMMM') == moment(pickedDay).format('dddd, DD MMMM') )
		{
			date = 'Today, ' + moment(pickedDay).format('DD MMMM');
		}
		
	if ( moment(tomorrowDate).format('dddd, DD MMMM') == moment(pickedDay).format('dddd, DD MMMM') )
		{
			date = 'Tomorrow, ' + moment(pickedDay).format('DD MMMM');
		}
	
	let temp = id;
		
	this.setState({
		chosenDay: temp,
		emptyState: this.state.classesDates.indexOf(date) == -1 ? date : ''
	});
}


  deleteRecording = (recItem) => {
	
	if ( window['electron'] && window['fsFile'] )
		{
			var $ = window.$ || {};
			$('.main_loader').attr({'style':'display:flex'});
			
			var mainThis = this;
			mainThis.recordSession.deleteOldRecordings(recItem);
			mainThis.reloadRecording();
		}
	  
  }
  
  
  
  pushRecording = (recItem) => {
		
		var $ = window.$ || {};
		var mainThis = this;
		mainThis.recordSession.applyNewRecording(recItem);
		
		mainThis.recordSession.uploadFileToS3(recItem['id'], function (passData)
			{
				if ( !passData )
					{
						mainThis.recordSession.hasRecordingFiles = false;
						mainThis.recordSession.isRecordingNow = false;
						
						console.log('all done');
						$('#session-saving-recording').modal('hide');
						$('#finished-upload-failed').modal('show');
						mainThis.reloadRecording();
						setTimeout(function () { $('.modal').modal('hide'); }, 2000);
					}
				else
					{
						mainThis.recordSession.saveFileForEC2(passData, function ()
							{
								console.log('all done');
								$('#session-saving-recording').modal('hide');
								$('#finished-upload').modal('show');
								mainThis.reloadRecording();
								setTimeout(function () { $('.modal').modal('hide'); }, 2000);
							});
					}
			});
	}
	
  reloadRecording = () => {
	
	var $ = window.$ || {};
	var mainThis = this;
	setTimeout(function ()
		{
			mainThis.recordSession.checkOldRecordings(function (foundFiles)
				{
					$('.main_loader').hide();
					if ( foundFiles )
						{
							console.log('Inside files', foundFiles);
							
							for ( var i = 0; i < foundFiles.length; i++ )
								{
									if ( foundFiles[i].hostId !== JSON.parse(localStorage.getItem('userData')).id ) 
										{
											foundFiles.splice(i, 1);
										}
								}
								
							if ( foundFiles.length > 0 )
								{
									mainThis.setState({'recordingsFound': true, 'recordingsList': foundFiles});
								}
							else
								{
									mainThis.setState({'recordingsFound': false, 'recordingsList': []});
								}
						}
						else
						{
							mainThis.setState({'recordingsFound': false, 'recordingsList': []});
						}
				});
		}, 2000);
  }

resetDate = ()=>{
	this.setState({
		chosenDay: '',
		emptyState:  ''
	});
}

showThisSessions=(mod)=>{
	this.props.searchFromMySchedule(mod);
}

  render() {
	 return (
		<div>
			<div className="class_container">
				<div className={(this.props.isOpenDetailedClass ? "d-none" : "" )}>
					<div className="filter_interest_container">
						<div className="calendar">
						<select className="nameMonth" id="currentMonthYear" value={this.state.currentMonthYear} onChange={(e)=>{this.choseMonth(e.target.value, true)}}>                     
							{this.state.monthsArray.map((row,i)=>
								<option key={i} value={row.date2}>{row.date}</option>
							)}  
						</select>
						</div>
						<div className="weekDays" id="weekDays"></div>
						<div className="monthDays" id="monthDays">
						{ this.state.calendarDays.map((item, i) =>
							<div className={" "+item.class1 + (this.state.chosenDay == item.value ? " chosenDay" : "")} key={i} onClick={() => (item.class1.indexOf('upcomDays') > -1 ? this.choseTime(item.value) : '' )}>
								<div className={" "+item.class2}>{item.value}</div>
									{ item.class3 && item.class3 != '' &&
										<div className={" "+item.class3}>
											{ item.value2 && item.value2.length > 0 &&
												<div className="book_inner">
													{ item.value2.map((val, ind) =>
														<div className={" "+val.class1} key={ind}></div>
													)}
												</div>
											}
										</div>
									}
							</div>
						)}
						</div>
						<div className="resetDateOut">
							<div className={"resetDate " + (this.state.chosenDay != '' ? 'active' : '')} onClick={this.resetDate}>Reset date</div>
						</div>
						{ this.state.currentUserData && this.state.currentUserData.showLiveAndOnDemand &&
							<div className="bookMarkClass" onClick={this.openBookmarks}>Bookmarked Classes</div>
						}
					</div>
					<div className={"classes_container " + ( ((this.state.classesDates.length == 0 && this.state.isLoadedClasses) || this.state.emptyState != '') ? "d-none" : "" )}>
					
						{ this.state.recordingsFound == true &&
							<div>
								<br />
								<hr/>
								<div className="msg_container">
									<div className="recording_msg">Oops! On-Demand Class recording upload failed.
										<div className="alert_icon"></div>
									</div>           
								</div>
								
								<table className="table">
									<thead>
										<tr>
											<th scope="col" className="text-left">Class Name</th>
											<th scope="col">Date & Time</th>
											<th scope="col">Action</th>
										</tr>
									</thead>
									<tbody>
										  { this.state.recordingsList.map((opt, i) =>
											  <tr key={i}>
												<td>{opt.name}</td>
												<td>{moment(opt.scheduleDate).format('MMM DD, YYYY @ h:mm A')}</td>
												<td id={opt.id}>
													<button type="button" className="btn-channel btn btn-large btn-primary py-1 px-4 rounded recbtns nBack" onClick={() => this.pushRecording(opt)}>UPLOAD RECORDING</button>
													&nbsp;&nbsp;
													<button type="button" className="btn-channel btn btn-large btn-primary py-1 px-4 rounded recbtns nBack" onClick={() => this.deleteRecording(opt)}>DELETE RECORDING</button>
												</td>
											  </tr>
											)}
									</tbody>
								</table>
							</div>
							}
						
						
						
						
						
					
					
						{ this.state.classesDates.map((date, index) =>
							<div className={"classes_holder " + ((this.state.chosenDay == '' || (this.state.chosenDay != '' && this.state.chosenDay == this.state.classDatesFormated[index])) ? "" : "d-none") } key={index}>
								<div className="class_dates">{date}</div>
								{ this.state.classesByInterest[date].map((item, i) => 
									<div className={"myScheduleContent " + ((item.timeUntil < this.state.defaultJoinTime*60) ? "canJoin" : "")} key={i}>
										<div className="class_content">
											<div className="left_class_content" onClick={() => item.marketplaceStatus != 0 ? this.openClassDetails(item.sessionId) : ''}>
												<div className="top_class_content">
													<div className={"class_icon " + ( item.isBookmarked == 1 ? "bookmarked_icon" : "" )} onClick={(e) => this.bookMarkClass(e, item)}></div>
													<div className="class_time">{moment(item.scheduleDate).format('hh:mm A')}</div>
													<div className="class_dot">&bull;</div>
													<div className="class_time">{item.sessionDuration} min</div>
													<div className="class_interest">{item.interestTitles}</div>
													{item.replayClassId > 0 &&
														<div className="class_interest">Replay</div>
													}
												</div>
												<div className="class_name">{item.sessionName}</div>
												<div className="bottom_class_content">
													<div className="instructor_avatar" style={{ backgroundImage: item.hostImage && item.hostImage.indexOf('.s3') > -1 ? "url("+item.hostImage+")" : "url(./images/user_avatar.svg)"}}></div>
													<div className="instructor_name">{item.hostFirstName} {item.hostLastName}</div>
												</div>
											</div>
											<div className="buttons_class_content">
												{ item.hostId != this.state.currentUserData.id ?
													<div>
														<div className={" " + (item.timeUntil > 0 ? 'outCancel': '')}>
															{ item.marketplaceStatus != 0 && <div className="bookedSign">Booked</div> }
															{ item.timeUntil > 0 &&
																<div className="class_inactive_btn" onClick={() => item.marketplaceStatus != 0 ? this.openCancel(item.sessionId) : ''}>{item.marketplaceStatus == 0 ? 'Booked' : 'Cancel'}</div>
															}
														</div>
													</div>
													:
													<div>
														<div className="bookedSign">Hosting</div>
													</div>
												}
											</div>
										</div>
										{ item.timeUntil < this.state.defaultJoinTime*60 &&
											<div className="joinSesButton" onClick={() => this.openClass(item.sessionId)}>
												{ item.timeUntil < 0 ?
													<div className="startingSign">Class in progress</div>
													:
													<div className="startingSign">Class starts in <span>{(item.timeUntil/60)>=10 ? Math.floor(item.timeUntil/60) : '0'+Math.floor(item.timeUntil/60)}</span> : <span>{(item.timeUntil-Math.floor(item.timeUntil/60)*60)>=10 ? (item.timeUntil-Math.floor(item.timeUntil/60)*60) : '0'+(item.timeUntil-Math.floor(item.timeUntil/60)*60)}</span></div>
												}
												<div className="joinSesSign">JOIN CLASS</div>
											</div>
										}
									</div>
								)}
							</div>
						)}
					</div>
					{ ((this.state.classesDates.length == 0 && this.state.isLoadedClasses) || this.state.emptyState != '') &&
						<div className="empty_state empty_state_schedule">
							{ this.state.emptyState != '' &&
								<div className="classDatesAbs">{this.state.emptyState}</div>
							}
							<div>
								<div className="emptyList"></div>
							</div>
							<div className="mrgtp26">
								<div className="emptyListTitle">It’s a bit empty here</div>
							</div>
							<div className="mrgtp26">
								<div className="emptyListSub">You don’t have any booked classes. 
									{ this.state.classInterests.length > 0 &&
										<span>Select the type of class that you would like to take</span>
									}
								</div>
							</div>
							{ this.state.currentUserData && this.state.currentUserData.showLiveAndOnDemand && this.state.showLiveTab == 1 ?
								<div className="emptyCatOut">
									<div className="hold_all_interests_width" >
										{ this.state.classInterests.map((item, i) =>
											<div className="oneEmptySub mrgR8" style={{ backgroundImage: "url("+item.image_icon+")"}} key={i} onClick={() => this.showThisSessions(item.id)} >{item.name}</div>
										)}
									</div>
								</div>
								:
								''
							}
						</div>
					}
				</div>
			</div>
			{ this.state.classBoking &&
				<CancelBooking updateStateFromChild={this.updateStateFromChild} cancelSessionStatus={this.cancelSessionStatus} sessionId={this.state.sessionToCancel}></CancelBooking>
			}
			{ this.state.isOpenBookmark &&
				<BookmarkedClasses 
					updateStateFromChild={this.updateStateFromChild}
					failedPaymentStatus={(this.props && this.props.state ? this.props.state.failedPaymentStatus : false)}
					renderChild = {this.state.renderChild}
					history={this.props.history}
				></BookmarkedClasses>
			}
			{ this.props.isOpenDetailedClass &&
				<LiveClassDetails
				failedPaymentStatus={(this.props && this.props.state ? this.props.state.failedPaymentStatus : false)}
				closeDetails={this.closeDetails} 
				updateParent={this.updateParent} 
				classInfo={this.state.classInfo} 
				getLiveClasses={this.refreshPage} 
				openClass={this.openClass}></LiveClassDetails>
			}
			
			
	  
	  
	  <div id="session-saving-recording" className="modal fade bg-transparent" data-backdrop="static" data-keyboard="false">
			<div className="modal-dialog modal-confirm modal-dialog-centered">
				<div className="modal-content bg-grayy px-4 position-relative radius-10">
					<div className="modal-header justify-content-center px-0 border-bottm">
						<h5 className="modal-title white_hdng">{Language.recordingPopUp.heading}</h5>
					</div>
					<div className="modal-body">
						<div>
							<p className="text-white font-20 mb-4">{Language.recordingPopUp.bodyMsg}</p>
							<div className="newprogressbar"><div></div></div>
							<div className="text-white newprogressbarinfo"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
  
		<div id="finished-upload" className="modal fade bg-transparent" data-backdrop="static" data-keyboard="false">
		  <div className="modal-dialog modal-confirm modal-dialog-centered">
			<div className="modal-content bg-grayy px-4 position-relative radius-10">
			  <div className="modal-body">
				<div>
				  <p className="text-white font-20 mb-4 recording_alert_hold">Recording uploaded successfully.</p>
				</div>
			  </div>
			</div>
		  </div>
		</div>
		
		 <div id="finished-upload-failed" className="modal fade bg-transparent" data-backdrop="static" data-keyboard="false">
		  <div className="modal-dialog modal-confirm modal-dialog-centered">
			<div className="modal-content bg-grayy px-4 position-relative radius-10">
			  <div className="modal-body">
				<div>
				  <p className="text-white font-20 mb-4 recording_alert_hold">Recording not uploaded.</p>
				</div>
			  </div>
			</div>
		  </div>
		</div>
		
		  <div id="retry-upload" className="modal fade bg-transparent" data-backdrop="static" data-keyboard="false">
			<div className="modal-dialog modal-confirm modal-dialog-centered">
			  <div className="modal-content bg-grayy px-4 position-relative radius-10">
				<div className="modal-body">
				  <div>
					<p className="text-white font-20 mb-4 recording_alert_hold">There is a problem with uploading recording. Please make sure you have stable internet connection and try again.</p>
				  </div>
				</div>
				<div className="ok_btn_cont">
				  <button className="ok-btn" onClick={ () => window.retryUploadRec() }>RETRY</button>
				  <button className="ok-btn" onClick={ () => window.stopUploadRec() }>CANCEL</button>
				</div>
			  </div>
			</div>
		  </div>
	  
      <div className="main_loader">
        <div className="main_loader_inner"></div>
      </div>
		</div>
    );
  }
}
export default connect(
  null,
  { 
	showMainErrorPop
  },
  null,
  {forwardRef: true}
)(MarketplaceMySchedule);